import { type StateCreator } from 'zustand';

import { type MiddlewareType, type SearchStore } from '../SearchStoreProvider';

export const MapMode = {
  MULTI_POLYGON_MODE: 'multi_polygon_mode',
  MULTI_POLYGON_MODE_DRAW: 'multi_polygon_mode_draw',
  MULTI_POLYGON_MODE_EDIT: 'multi_polygon_mode_edit',
  BOUNDING_BOX_MODE: 'bounding_box_mode',
  PLACE_MODE: 'place_mode',
} as const;

export type MapMode = (typeof MapMode)[keyof typeof MapMode];

const POLYGON_MAP_MODES: ReadonlySet<MapMode> = new Set([
  MapMode.MULTI_POLYGON_MODE,
  MapMode.MULTI_POLYGON_MODE_DRAW,
  MapMode.MULTI_POLYGON_MODE_EDIT,
]);

/** True when map search uses the polygon / freedraw interaction model (idle, drawing, or editing). */
export const isPolygonMapMode = (mapMode?: MapMode): boolean => mapMode != null && POLYGON_MAP_MODES.has(mapMode);

/** True when the user is actively drawing or editing polygons on the map. */
export const isPolygonDrawOrEditMapMode = (mapMode?: MapMode): boolean =>
  mapMode === MapMode.MULTI_POLYGON_MODE_DRAW || mapMode === MapMode.MULTI_POLYGON_MODE_EDIT;

export type MapInteractionState = {
  mapMode?: MapMode;
};

type MapInteractionActions = {
  setMapMode: (mapMode?: MapMode) => void;
};

export type MapInteractionStore = MapInteractionState & MapInteractionActions;

export const defaultMapInteractionState: Readonly<MapInteractionState> = {};

export const createMapInteractionSlice: StateCreator<SearchStore, MiddlewareType, [], MapInteractionStore> = (set) => ({
  ...defaultMapInteractionState,
  setMapMode: (mapMode?: MapMode) => {
    set({ mapMode }, undefined, 'setMapMode');
  },
});
